import { TextField, Button, Collapse, List, ListItem, ListItemText } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import React, { useState, useEffect } from 'react'
import { useFormik } from 'formik'
import axios from 'axios'
import { useRecoilState } from 'recoil'
import { chequeSettingsState } from '../recoil/atoms'
import { ExpandLess, ExpandMore } from '@material-ui/icons'

const useStyles = makeStyles((theme) => ({
    nested: {
        paddingLeft: theme.spacing(4),
    },
}))


const EditChequeSetting = props => {
    const [chequeSettings, setChequeSettings] = useRecoilState(chequeSettingsState)
    const [chequeSetting, setChequeSetting] = useState({})
    // Get cheque settings
    const getChequeSettingData = async () => {
        const data = await axios.get('accounts/cheque_setting/?id=' + props.id).then(result => result.data)
        setChequeSetting(data)
    }
    useEffect(() => {
        getChequeSettingData()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    const formik = useFormik({
        initialValues: {
            title: chequeSetting.title,
            dateInWordsTop: chequeSetting.date_in_words_top,
            dateInWordsLeft: chequeSetting.date_in_words_left,
            dateInDigitsTop: chequeSetting.date_in_digits_top,
            dateInDigitsLeft: chequeSetting.date_in_digits_left,
            maxAmountPixelsInRow: chequeSetting.max_amount_pixels_in_row,
            amountInWordsTop: chequeSetting.amount_in_words_top,
            amountInWordsLeft: chequeSetting.amount_in_words_left,
            amountInDigitsTop: chequeSetting.amount_in_digits_top,
            amountInDigitsLeft: chequeSetting.amount_in_digits_left,
            maxPayToPixelsInRow: chequeSetting.max_payto_pixels_in_row,
            payToTop: chequeSetting.payto_top,
            payToLeft: chequeSetting.payto_left,
            signature1Top: chequeSetting.signature1_top,
            signature1Left: chequeSetting.signature1_left,
            signature2Top: chequeSetting.signature2_top,
            signature2Left: chequeSetting.signature2_left,
            perforationTop: chequeSetting.perforation_top,
            perforationLeft: chequeSetting.perforation_left,
            stubDateTop: chequeSetting.stub_date_top,
            stubDateLeft: chequeSetting.stub_date_left,
            stubMaxPayToPixelsInRow: chequeSetting.stub_max_payto_pixels_in_row,
            stubPayToTop: chequeSetting.stub_payto_top,
            stubPayToLeft: chequeSetting.stub_payto_left,
            stubAmountTop: chequeSetting.stub_amount_top,
            stubAmountLeft: chequeSetting.stub_amount_left,
        },
        enableReinitialize: true,
        onSubmit: values => {
            axios.put('accounts/cheque_setting/', {
                id: chequeSetting.id,
                title: values.title,
                date_in_words_top: Number(values.dateInWordsTop),
                date_in_words_left: Number(values.dateInWordsLeft),
                date_in_digits_top: Number(values.dateInDigitsTop),
                date_in_digits_left: Number(values.dateInDigitsLeft),
                max_amount_pixels_in_row: Number(values.maxAmountPixelsInRow),
                amount_in_words_top: Number(values.amountInWordsTop),
                amount_in_words_left: Number(values.amountInWordsLeft),
                amount_in_digits_top: Number(values.amountInDigitsTop),
                amount_in_digits_left: Number(values.amountInDigitsLeft),
                max_payto_pixels_in_row: Number(values.maxPayToPixelsInRow),
                payto_top: Number(values.payToTop),
                payto_left: Number(values.payToLeft),
                signature1_top: Number(values.signature1Top),
                signature1_left: Number(values.signature1Left),
                signature2_top: Number(values.signature2Top),
                signature2_left: Number(values.signature2Left),
                perforation_top: Number(values.perforationTop),
                perforation_left: Number(values.perforationLeft),
                stub_date_top: Number(values.stubDateTop),
                stub_date_left: Number(values.stubDateLeft),
                stub_max_payto_pixels_in_row: Number(values.stubMaxPayToPixelsInRow),
                stub_payto_top: Number(values.stubPayToTop),
                stub_payto_left: Number(values.stubPayToLeft),
                stub_amount_top: Number(values.stubAmountTop),
                stub_amount_left: Number(values.stubAmountLeft),
            }).then(result => {
                let newData = chequeSettings.map(cheque => { return { id: cheque.id, title: cheque.title } })
                newData[newData.findIndex(cheque => cheque.id === props.id)] = result.data
                setChequeSettings(newData)
                props.setPopup(false)
            })
        }
    })
    const classes = useStyles()
    const [dateOpen, setDateOpen] = useState(false)
    const [amountOpen, setAmountOpen] = useState(false)
    const [payToOpen, setPayToOpen] = useState(false)
    const [signatureOpen, setSignatureOpen] = useState(false)
    const [perforationOpen, setPerforationOpen] = useState(false)
    return (
        <form onSubmit={formik.handleSubmit}>
            <TextField
                id="title"
                label="عنوان چک"
                fullWidth
                value={formik.values.title}
                onChange={formik.handleChange}
            />
            {/* Date */}
            <ListItem button onClick={() => setDateOpen(!dateOpen)}>
                <ListItemText primary="تاریخ" />
                {dateOpen ? <ExpandLess /> : <ExpandMore />}
            </ListItem>
            <Collapse in={dateOpen} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                    <ListItem button className={classes.nested}>
                        <TextField
                            id="dateInWordsTop"
                            label="تاریخ به حروف (فاصله از بالا)"
                            fullWidth
                            value={formik.values.dateInWordsTop}
                            onChange={formik.handleChange}
                        />
                    </ListItem>
                    <ListItem button className={classes.nested}>
                        <TextField
                            id="dateInWordsLeft"
                            label="تاریخ به حروف (فاصله از چپ)"
                            fullWidth
                            value={formik.values.dateInWordsLeft}
                            onChange={formik.handleChange}
                        />
                    </ListItem>
                    <ListItem button className={classes.nested}>
                        <TextField
                            id="dateInDigitsTop"
                            label="تاریخ به عدد (فاصله از بالا)"
                            fullWidth
                            value={formik.values.dateInDigitsTop}
                            onChange={formik.handleChange}
                        />
                    </ListItem>
                    <ListItem button className={classes.nested}>
                        <TextField
                            id="dateInDigitsLeft"
                            label="تاریخ به عدد (فاصله از چپ)"
                            fullWidth
                            value={formik.values.dateInDigitsLeft}
                            onChange={formik.handleChange}
                        />
                    </ListItem>
                    <ListItem button className={classes.nested}>
                        <TextField
                            id="stubDateTop"
                            label="تاریخ ته چک (فاصله از بالا)"
                            fullWidth
                            value={formik.values.stubDateTop}
                            onChange={formik.handleChange}
                        />
                    </ListItem>
                    <ListItem button className={classes.nested}>
                        <TextField
                            id="stubDateLeft"
                            label="تاریخ ته چک (فاصله از چپ)"
                            fullWidth
                            value={formik.values.stubDateLeft}
                            onChange={formik.handleChange}
                        />
                    </ListItem>
                </List>
            </Collapse>
            {/* Amount */}
            <ListItem button onClick={() => setAmountOpen(!amountOpen)}>
                <ListItemText primary="مبلغ" />
                {amountOpen ? <ExpandLess /> : <ExpandMore />}
            </ListItem>
            <Collapse in={amountOpen} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                    <ListItem button className={classes.nested}>
                        <TextField
                            id="maxAmountPixelsInRow"
                            label="حداکثر پیکسل مبلغ در ردیف"
                            fullWidth
                            value={formik.values.maxAmountPixelsInRow}
                            onChange={formik.handleChange}
                        />
                    </ListItem>
                    <ListItem button className={classes.nested}>
                        <TextField
                            id="amountInWordsTop"
                            label="مبلغ به حروف (فاصله از بالا)"
                            fullWidth
                            value={formik.values.amountInWordsTop}
                            onChange={formik.handleChange}
                        />
                    </ListItem>
                    <ListItem button className={classes.nested}>
                        <TextField
                            id="amountInWordsLeft"
                            label="مبلغ به حروف (فاصله از چپ)"
                            fullWidth
                            value={formik.values.amountInWordsLeft}
                            onChange={formik.handleChange}
                        />
                    </ListItem>
                    <ListItem button className={classes.nested}>
                        <TextField
                            id="amountInDigitsTop"
                            label="مبلغ به عدد (فاصله از بالا)"
                            fullWidth
                            value={formik.values.amountInDigitsTop}
                            onChange={formik.handleChange}
                        />
                    </ListItem>
                    <ListItem button className={classes.nested}>
                        <TextField
                            id="amountInDigitsLeft"
                            label="مبلغ به عدد (فاصله از چپ)"
                            fullWidth
                            value={formik.values.amountInDigitsLeft}
                            onChange={formik.handleChange}
                        />
                    </ListItem>
                    <ListItem button className={classes.nested}>
                        <TextField
                            id="stubAmountTop"
                            label="مبلغ ته چک (فاصله از بالا)"
                            fullWidth
                            value={formik.values.stubAmountTop}
                            onChange={formik.handleChange}
                        />
                    </ListItem>
                    <ListItem button className={classes.nested}>
                        <TextField
                            id="stubAmountLeft"
                            label="مبلغ ته چک (فاصله از چپ)"
                            fullWidth
                            value={formik.values.stubAmountLeft}
                            onChange={formik.handleChange}
                        />
                    </ListItem>
                </List>
            </Collapse>
            {/* PayTo */}
            <ListItem button onClick={() => setPayToOpen(!payToOpen)}>
                <ListItemText primary="گیرنده" />
                {payToOpen ? <ExpandLess /> : <ExpandMore />}
            </ListItem>
            <Collapse in={payToOpen} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                    <ListItem button className={classes.nested}>
                        <TextField
                            id="maxPayToPixelsInRow"
                            label="حداکثر پیکسل گیرنده در ردیف"
                            fullWidth
                            value={formik.values.maxPayToPixelsInRow}
                            onChange={formik.handleChange}
                        />
                    </ListItem>
                    <ListItem button className={classes.nested}>
                        <TextField
                            id="payToTop"
                            label="گیرنده (فاصله از بالا)"
                            fullWidth
                            value={formik.values.payToTop}
                            onChange={formik.handleChange}
                        />
                    </ListItem>
                    <ListItem button className={classes.nested}>
                        <TextField
                            id="payToLeft"
                            label="گیرنده (فاصله از چپ)"
                            fullWidth
                            value={formik.values.payToLeft}
                            onChange={formik.handleChange}
                        />
                    </ListItem>
                    <ListItem button className={classes.nested}>
                        <TextField
                            id="stubMaxPayToPixelsInRow"
                            label="حداکثر پیکسل گیرنده در ردیف ته چک"
                            fullWidth
                            value={formik.values.stubMaxPayToPixelsInRow}
                            onChange={formik.handleChange}
                        />
                    </ListItem>
                    <ListItem button className={classes.nested}>
                        <TextField
                            id="stubPayToTop"
                            label="گیرنده ته چک (فاصله از بالا)"
                            fullWidth
                            value={formik.values.stubPayToTop}
                            onChange={formik.handleChange}
                        />
                    </ListItem>
                    <ListItem button className={classes.nested}>
                        <TextField
                            id="stubPayToLeft"
                            label="گیرنده ته چک (فاصله از چپ)"
                            fullWidth
                            value={formik.values.stubPayToLeft}
                            onChange={formik.handleChange}
                        />
                    </ListItem>
                </List>
            </Collapse>
            {/* Signature */}
            <ListItem button onClick={() => setSignatureOpen(!signatureOpen)}>
                <ListItemText primary="امضا کننده" />
                {signatureOpen ? <ExpandLess /> : <ExpandMore />}
            </ListItem>
            <Collapse in={signatureOpen} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                    <ListItem button className={classes.nested}>
                        <TextField
                            id="signature1Top"
                            label="امضا کننده اول (فاصله از بالا)"
                            fullWidth
                            value={formik.values.signature1Top}
                            onChange={formik.handleChange}
                        />
                    </ListItem>
                    <ListItem button className={classes.nested}>
                        <TextField
                            id="signature1Left"
                            label="امضا کننده اول (فاصله از چپ)"
                            fullWidth
                            value={formik.values.signature1Left}
                            onChange={formik.handleChange}
                        />
                    </ListItem>
                    <ListItem button className={classes.nested}>
                        <TextField
                            id="signature2Top"
                            label="امضا کننده دوم (فاصله از بالا)"
                            fullWidth
                            value={formik.values.signature2Top}
                            onChange={formik.handleChange}
                        />
                    </ListItem>
                    <ListItem button className={classes.nested}>
                        <TextField
                            id="signature2Left"
                            label="امضا کننده دوم (فاصله از چپ)"
                            fullWidth
                            value={formik.values.signature2Left}
                            onChange={formik.handleChange}
                        />
                    </ListItem>
                </List>
            </Collapse>
            {/* Perforation */}
            <ListItem button onClick={() => setPerforationOpen(!perforationOpen)}>
                <ListItemText primary="پرفراژ" />
                {perforationOpen ? <ExpandLess /> : <ExpandMore />}
            </ListItem>
            <Collapse in={perforationOpen} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                    <ListItem button className={classes.nested}>
                        <TextField
                            id="perforationTop"
                            label="پرفراژ (فاصله از بالا)"
                            fullWidth
                            value={formik.values.perforationTop}
                            onChange={formik.handleChange}
                        />
                    </ListItem>
                    <ListItem button className={classes.nested}>
                        <TextField
                            id="perforationLeft"
                            label="پرفراژ (فاصله از چپ)"
                            fullWidth
                            value={formik.values.perforationLeft}
                            onChange={formik.handleChange}
                        />
                    </ListItem>
                </List>
            </Collapse>
            <Button
                type="submit"
                fullWidth
                variant="contained"
                color="primary"
                style={{ marginTop: 10 }}
                disabled={formik.isSubmitting}
            >
                ویرایش
            </Button>
        </form>
    )
}

export default EditChequeSetting